import { render, staticRenderFns } from "./ComPlie.vue?vue&type=template&id=62bf3066&scoped=true"
import script from "./ComPlie.vue?vue&type=script&lang=js"
export * from "./ComPlie.vue?vue&type=script&lang=js"
import style0 from "./ComPlie.vue?vue&type=style&index=0&id=62bf3066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf3066",
  null
  
)

export default component.exports